module.exports = __webpack_public_path__ + "static/404-backgrond-57ee4ea2c2ebe59d73676d3ff770dd16.jpg";